<script>
import userAccessMixin from "../../../mixins/userAccessMixin";
import { mapActions, mapState } from "vuex";
import UserLookup from "../../admin/users/Lookup";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const API_ENDPOINT = "/api/reports";
export default {
  components: {
    CustomDatepicker,
    UserLookup
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    selectedUser: {},
    userTranDialog: false,
    userActions: [],
    userActionsH: [
      {
        text: "",
        value: "actions",
        sortable: false
      },
      {
        text: "Trans",
        value: "trans"
      }
    ],
    actionSearch: null,
    isGeneratingReport: false,
    reportParam: {
      dateFrom: null,
      dateTo: null,
      empCode: null,
      transaction: null,
      menuCode: null
    }
  }),
  computed: {
    ...mapState("group", {
      loading: state => state.loading,
      groups: state => state.groups,
      classMenus: state => state.classMenus,
      classMenuLoading: state => state.classMenuLoading
    })
  },
  methods: {
    ...mapActions("group", ["getAll", "getAllClassMenus"]),
    async generateAuditReport() {
      if (!this.validation()) return;

      try {
        this.isGeneratingReport = true;

        const { data } = await this.$axios.post(
          `${API_ENDPOINT}/ExportAuditTrail`,
          this.reportParam,
          {
            responseType: "blob"
          }
        );

        const href = URL.createObjectURL(data);

        const link = document.createElement("a");
        link.href = href;
        link.setAttribute(
          "download",
          `Audit_Trail_${this.dateFrom}_${this.dateTo}.xlsx`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } finally {
        this.isGeneratingReport = false;
      }
    },
    getUserTrans() {
      this.$axios
        .get(`/api/auditTrail/user-trans`)
        .then(({ data }) => {
          this.userActions = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    validation() {
      if (!this.dateFrom && this.dateTo) {
        this.$toast.error("Select Date.");
        return false;
      }

      const dateFrom = new Date(this.dateFrom);
      const dateTo = new Date(this.dateTo);
      if (dateFrom > dateTo) {
        this.$toast.error("Date From must not greater than Date To");
        return false;
      }
      if (dateTo < dateFrom) {
        this.$toast.error("Date To must not less than Date From.");
        return false;
      }
      return true;
    }
  },
  created() {
    this.getUserTrans();
    this.getAllClassMenus();
    this.getUserAccessRights("AuditR");
  }
};
</script>

<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <user-lookup
            :class-padding="classPadding"
            v-model="selectedUser"
            label="Employee Code"
            title="Users"
            :code-value="true"
          ></user-lookup>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field
            label="Name"
            :value="selectedUser.desc"
            :class="classPadding"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Action"
            v-model="reportParam.transaction"
            clearable
            @click:clear="reportParam.transaction = null"
            :class="classPadding"
            readonly
          >
            <template slot="append">
              <v-icon @click.prevent="userTranDialog = true"
                >mdi-magnify</v-icon
              >
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
          <v-text-field
            label="Message"
            :class="classPadding"
            v-model="reportParam.message"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date From"
            v-model="reportParam.dateFrom"
            required
          ></custom-datepicker>
        </v-col>
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <custom-datepicker
            :class-padding="classPadding"
            label="Date To"
            v-model="reportParam.dateTo"
            required
          ></custom-datepicker>
        </v-col>
        <v-col xs="12" md="4" sm="6" :class="classPadding">
          <v-select
            :items="classMenus"
            item-value="menuCode"
            item-text="menuDesc"
            :loading="classMenuLoading"
            label="Menu Type"
            v-model="reportParam.menuCode"
            clearable
            :class="classPadding"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="generateAuditReport"
            :loading="isGeneratingReport"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="userTranDialog" width="700" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Users Action</span>
        </v-card-title>
        <v-card-text>
          <!-- <list :show-dense="false" :show-title="false" :headers="headers">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="select(item)" text outlined>Select</v-btn>
            </template>
          </list>-->
          <v-text-field label="Search" v-model="actionSearch"></v-text-field>
          <v-data-table
            :items="userActions"
            :headers="userActionsH"
            :search="actionSearch"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn @click.stop="select(item)" text outlined>Select</v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="userTranDialog = false" text
            >CLose</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
